import { useEffect, useState } from "react";
import { Newspaper } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api from "@/api";
import { formatDate } from "@/constants";

export default function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/news")
      .then((r) => setNews(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="py-12 sm:py-16 lg:py-20" data-testid="news-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-600 mb-2">Vie de l'association</p>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="news-title">Actualités</h1>
          <p className="text-base text-slate-600 mt-3">
            Les dernières nouvelles de l'association : événements passés, projets en cours et informations pratiques.
          </p>
        </div>
        {loading ? (
          <p className="text-sm text-slate-500" data-testid="news-loading">Chargement…</p>
        ) : news.length === 0 ? (
          <p className="text-sm text-slate-500 bg-white rounded-xl border border-slate-200 p-6" data-testid="news-empty">
            Aucune actualité publiée pour le moment.
          </p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {news.map((n) => (
              <Card
                key={n.id}
                className="border-slate-200 hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => setSelected(n)}
                data-testid={`news-card-${n.id}`}
              >
                <CardContent className="p-6 space-y-3">
                  <Badge className="bg-sky-100 text-sky-800 border border-sky-200 hover:bg-sky-100">
                    <Newspaper className="h-3 w-3 mr-1" />{formatDate(n.created_at)}
                  </Badge>
                  <h3 className="text-lg font-semibold text-slate-800">{n.title}</h3>
                  <p className="text-sm text-slate-600 line-clamp-4">{n.content}</p>
                  <span className="text-sm font-medium text-sky-700">Lire la suite →</span>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>

      <Dialog open={!!selected} onOpenChange={() => setSelected(null)}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="news-dialog">
          {selected && (
            <>
              <DialogHeader>
                <DialogTitle className="font-heading text-xl">{selected.title}</DialogTitle>
                <DialogDescription>
                  Publié le {formatDate(selected.created_at)}{selected.author ? ` par ${selected.author}` : ""}
                </DialogDescription>
              </DialogHeader>
              <p className="text-sm sm:text-base leading-relaxed text-slate-700 whitespace-pre-line">{selected.content}</p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
